export default "/images/de5ea5862c4fc9e5e77c61d6464d8fd0.avif";